export const basePath = '/companies';

export * from './getCompanyContactInfo';
export * from './updateCompanyContactInfo';
